export const CONTENT_PACK_TEXT_NAME_KEY_PREFIX = 'redeem-success__gift-description';
export const CONTENT_PACK_TEXT_DESCRIPTION_KEY_PREFIX = 'redeem-success__gift-details';
export const REWARDS_TIER_TEXT_KEY_PREFIX = 'friends-referral__rewards__tier-';
